import { changeCellStyle, getCurrentDateTimeForFileName } from "components/CommonLib/CommonLib";
import { utils, writeFile } from "xlsx-js-style";

export const exportCartToExcel = (cartItems, branchName, time) => {
  const data = [];
  const emptyRow = Array(8).fill("");
  const totalQuantity = cartItems.reduce((acc, i) => acc + i.quantity, 0);
  data.push([...emptyRow]);

  // 제목 행
  data.push([changeCellStyle("기자재 구매 요청서", "lightGray", "left")]);

  // 지점/일시 행
  data.push([
    changeCellStyle(`${branchName}`, "lightGray", "left"),
    changeCellStyle(`${time}`, "lightGray", "left"),
  ]);

  // 컬럼 헤더 행
  data.push([
    changeCellStyle("No.", "lightBlue", "left"),
    changeCellStyle("제품명", "lightBlue", "left"),
    changeCellStyle("시리즈", "lightBlue", "left"),
    changeCellStyle("모델", "lightBlue", "left"),
    changeCellStyle("양식", "lightBlue", "left"),
    changeCellStyle("단가", "lightBlue", "allCenter"),
    changeCellStyle("수량", "lightBlue", "allCenter"),
    changeCellStyle("금액", "lightBlue", "allCenter"),
  ]);

  // 데이터 행
  cartItems.forEach((item, index) => {
    data.push([
      changeCellStyle(index + 1, "", "left"),
      changeCellStyle(item.name, "", "left"),
      changeCellStyle(item.series, "", "left"),
      changeCellStyle(item.model, "", "left"),
      changeCellStyle(item.format, "", "left"),
      changeCellStyle(item.price ?? 0, "", "right"),
      changeCellStyle(item.quantity, "", "right"),
      changeCellStyle((item.price ?? 0) * item.quantity, "", "right"),
    ]);
  });

  // 합계 행
  data.push([
    changeCellStyle("합계", "lightOrange", "left"),
    changeCellStyle("", "lightOrange", "left"),
    changeCellStyle("", "lightOrange", "left"),
    changeCellStyle("", "lightOrange", "left"),
    changeCellStyle("", "lightOrange", "left"),
    changeCellStyle("", "lightOrange", "left"),
    changeCellStyle(`${totalQuantity}`, "lightOrange", "right"),
    changeCellStyle(
      cartItems.reduce((acc, i) => acc + (i.price ?? 0) * i.quantity, 0),
      "lightOrange",
      "right",
    ),
  ]);

  const fileName = `기자재_구매요청_${branchName}_${getCurrentDateTimeForFileName()}`;
  const worksheet = utils.aoa_to_sheet(data);

  // 컬럼별 너비 개별 지정
  worksheet["!cols"] = [
    { wch: 20 },
    { wch: 32 },
    { wch: 20 },
    { wch: 20 },
    { wch: 20 },
    { wch: 20 },
    { wch: 20 },
    { wch: 20 },
  ];

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, `${branchName} 기자재 구매요청`);
  writeFile(workbook, fileName + ".xlsx");
};
